import { Pipe, PipeTransform } from '@angular/core';
import getCardOrder from './campaign-drawer.util';

@Pipe({ name: 'getCardOrder', standalone: true })
export class GetCardOrderPipe implements PipeTransform {

    transform(index: number, count: number): number {
        return getCardOrder(index, count);
    }
}
